var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.3333 17.5V15.8333C13.3333 14.9493 12.9821 14.1014 12.3569 13.4763C11.7318 12.8512 10.884 12.5 9.99992 12.5H4.16658C3.28253 12.5 2.43468 12.8512 1.80956 13.4763C1.18444 14.1014 0.833252 14.9493 0.833252 15.8333V17.5M16.6666 6.66667V11.6667M19.1666 9.16667H14.1666M10.4166 5.83333C10.4166 7.67428 8.9242 9.16667 7.08325 9.16667C5.2423 9.16667 3.74992 7.67428 3.74992 5.83333C3.74992 3.99238 5.2423 2.5 7.08325 2.5C8.9242 2.5 10.4166 3.99238 10.4166 5.83333Z",
    stroke: "#20B3D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlusBlue);
export default __webpack_public_path__ + "static/media/userPlusBlue.66958469ef89d7f97618c56060b1ae4b.svg";
export { ForwardRef as ReactComponent };